<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUnidade"
                            :options="form.unidades"
                            @change="loadFrom('unidade')"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableInfraestrutura"
                            :options="form.infraestruturas"
                            @change="loadFrom('infraestrutura')"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :disabled="disableStatus"
                            :options="form.status"
                            @change="loadFrom('status')"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            v-model="model.status"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :default-option-text="model.status ? 'Nenhuma' : 'Todas'"
                            :disabled="disableSituacoes"
                            :options="form.situacoes"
                            @change="loadFrom('situacao')"
                            label="Situação"
                            show-default-option
                            text-field="nome"
                            v-model="model.situacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableOcupacao"
                            :options="form.ocupacoes"
                            @change="loadFrom('ocupacao')"
                            default-option-text="Todas"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableEspecialidade"
                            :options="form.especialidades"
                            @change="loadFrom('especialidade')"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUsuario"
                            :options="form.usuarios"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>


            <rkm-table
                :fields="fields"
                :foot-clone="itens.length > 0"
                :items="itens"
                no-footer-sorting
            >
                <template #beforeTable>
                    <p class="legenda p-0 m-0 text-right">
                        A = AGENDADAS | APP = APP CIDADÃO | C = CONSULTA | R = RETORNO | T = TOTAL 
                    </p>
                </template>

                <template #cell(situacaoNome)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(quantidadeConsulta)="{ item }">
                    <span>{{ item.quantidadeConsultaAgendado }}/{{ item.quantidadeConsultaTotal }}</span>
                </template>

                <template #cell(quantidadeRetorno)="{ item }">
                    <span>{{ item.quantidadeRetornoAgendado }}/{{ item.quantidadeRetornoTotal }}</span>
                </template>

                <template #cell(quantidadeTotal)="{ item }">
                    <span>{{ item.quantidadeTotalAgendado }}/{{ item.quantidadeTotalTotal }}</span>
                </template>

                <template #cell(quantidadeConsultaApp)="{ item }">
                    <span>{{ item.quantidadeConsultaAppAgendado }}/{{ item.quantidadeConsultaAppTotal }}</span>
                </template>

                <template #cell(quantidadeRetornoApp)="{ item }">
                    <span>{{ item.quantidadeRetornoAppAgendado }}/{{ item.quantidadeRetornoAppTotal }}</span>
                </template>

                <template #foot(data)>
                    <span></span>
                </template>

                <template #foot(diaSemana)>
                    <span></span>
                </template>

                <template #foot(unidadeNomeFantasia)>
                    <span></span>
                </template>

                <template #foot(infraestruturaNome)>
                    <span></span>
                </template>

                <template #foot(ocupacaoCodigo)>
                    <span></span>
                </template>

                <template #foot(especialidadeNome)>
                    <span></span>
                </template>

                <template #foot(usuarioNome)>
                    <span></span>
                </template>

                <template #foot(inicio)>
                    <span></span>
                </template>

                <template #foot(fim)>
                    <span></span>
                </template>

                <template #foot(status)>
                    <span></span>
                </template>

                <template #foot(situacaoNome)>
                    <span></span>
                </template>

                <template #foot(quantidadeConsulta)>
                    <span>{{ getSafely(() => totalizadores.quantidadeConsulta.agendado, 0) }}/{{ getSafely(() => totalizadores.quantidadeConsulta.total, 0) }}</span>
                </template>

                <template #foot(quantidadeRetorno)>
                    <span>{{ getSafely(() => totalizadores.quantidadeRetorno.agendado, 0) }}/{{ getSafely(() => totalizadores.quantidadeRetorno.total, 0) }}</span>
                </template>

                <template #foot(quantidadeTotal)>
                    <span>{{ getSafely(() => totalizadores.quantidadeTotal.agendado, 0) }}/{{ getSafely(() => totalizadores.quantidadeTotal.total, 0) }}</span>
                </template>

                <template #foot(quantidadeConsultaApp)> 
                    <span>{{ getSafely(() => totalizadores.quantidadeConsultaApp.agendado, 0) }}/{{ getSafely(() => totalizadores.quantidadeConsultaApp.total, 0) }}</span>
                </template>

                <template #foot(quantidadeRetornoApp)> 
                    <span>{{ getSafely(() => totalizadores.quantidadeRetornoApp.agendado, 0) }}/{{ getSafely(() => totalizadores.quantidadeRetornoApp.total, 0) }}</span>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, formats, error, data, object, stringCase, file } from '@/mixins'

export default {
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: { required: true },
            }
        },
        disableUnidade() {

            return !this.isPeriodoSelecionado
        },
        disableInfraestrutura() {

            return !this.isPeriodoSelecionado
                || this.model.unidadeId === null
        },
        disableStatus() {

            return !this.isPeriodoSelecionado
        },
        disableSituacoes() {

            return !this.isPeriodoSelecionado
                || this.model.status !== false
        },
        disableOcupacao() {

            return !this.isPeriodoSelecionado
        },
        disableEspecialidade() {

            return !this.isPeriodoSelecionado
                || this.model.ocupacaoId === null
        },
        disableUsuario() {

            return !this.isPeriodoSelecionado
        },
        isPeriodoSelecionado() {

            return this.model !== null
                && (this.model.periodo.start instanceof Date)
                && (this.model.periodo.end instanceof Date)
        },
    },
    created() {

        this.repositories = {
            relatorioJornada: this.getConectaSusRepository('ambulatorio.relatorioJornada'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            initials: {
                form: null,
                model: null,
            },
            selectedAll: false,
            indeterminate: true,
            selectedCols: [
                'diaSemana',
                'ocupacaoCodigo',
                'especialidadeNome',
                'usuarioNome',
                'inicio',
                'fim',
                'status',
                'quantidadeConsulta',
                'quantidadeRetorno',
                'quantidadeTotal',
            ],
            columns: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                    class: 'col-min',
                    formatter: value => this.formatDate(value),
                    filterByFormatted: true,
                    fixed: true,
                },
                { key: 'diaSemana', label: 'Dia', sortable: true, class: 'col-min' },
                { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                { key: 'ocupacaoCodigo', label: 'CBO', sortable: true, class: 'col-min' },
                { key: 'especialidadeNome', label: 'Especialidade', sortable: true },
                { key: 'usuarioNome', label: 'Profissional', sortable: true },
                { key: 'inicio', label: 'Início', sortable: true, class: 'col-min' },
                { key: 'fim', label: 'Fim', sortable: true, class: 'col-min' },
                { key: 'status', label: 'Status', sortable: true },
                { key: 'situacaoNome', label: 'Situação', sortable: true },
                { key: 'quantidadeConsultaApp', label: 'A/C APP', class: 'col-min text-center' },
                { key: 'quantidadeRetornoApp', label: 'A/R APP', class: 'col-min text-center' },
                { key: 'quantidadeConsulta', label: 'A/C', class: 'col-min text-center' },
                { key: 'quantidadeRetorno', label: 'A/R', class: 'col-min text-center' },
                { key: 'quantidadeTotal', label: 'A/T', class: 'col-min text-center' },
            ],
            itens: [],
            totalizadores: null,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.relatorioJornada.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(data.form)
                    this.initials.model = this.clone(data.model)

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.start === null || periodo.end === null) {

                        this.resetAfterPeriodo()
                    }
                    else {

                        this.loadFrom('periodo')
                    }
                }
            })
        },
        loadFrom(field) {

            this.clearFrom(field)

            this.setLoading()

            this.repositories.relatorioJornada.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearFrom(field) {

            if (field == 'periodo') {

                return
            }

            if (field !== 'status') {

                field = `${field}Id`
            }

            const fields = [
                'unidadeId',
                'infraestruturaId',
                'status',
                'situacaoId',
                'ocupacaoId',
                'especialidadeId',
                'usuarioId',
            ]

            fields.slice(fields.indexOf(field) + 1, fields.length)
                .forEach(key => this.$set(this.model, key, null))
        },
        search() {

            this.setLoading()

            this.repositories.relatorioJornada.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data.jornadas
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form = this.clone(this.initials.form)
            this.model = this.clone(this.initials.model)

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        resetAfterPeriodo() {

            this.form = this.clone(this.initials.form)

            const model = this.clone(this.initials.model)

            delete model.periodo

            Object.keys(model).forEach(key => this.$set(this.model, key, model[key]))
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioJornada(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.columns = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [repository, formats, error, data, object, stringCase, file],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}

.legenda {
    color: var(--gray-dark);
    font-weight: 600;
}
</style>